import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import clsx from "clsx";

// Component Imports
import PageLayout from "../../components/PageLayout";
import { SectionHeading } from "../../components/SectionHeading";

const HeroSection: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className="grid grid-cols-1 md:grid-cols-5 gap-4 my-6 md:my-10 pt-20">
      <div className="flex flex-col justify-center col-span-1 md:col-span-3 text-center md:text-left order-2 md:order-1 mt-4 md:mt-0">
        <SectionHeading>{t('HitchhikingHero1')}<br/>{t('HitchhikingHero1Note')}</SectionHeading>
        <br/>
        <p className="text-sm md:text-base">
          {t('HitchhikingHero2')}
        </p>
      </div>
      <div className="col-span-1 md:col-span-2 flex justify-center order-1 md:order-2 mb-2 md:mb-0">
        <img
          src="../../../image/hitchhiking_icon.png"
          alt="Hitchhiking icon"
          className="w-[30%] md:w-auto"
        />
      </div>
    </div>
  )
}

const DescriptionSection: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 my-6 md:my-10">
      <div className="col-span-1 md:col-span-3 text-center">
        <SectionHeading size="xl">{t('HitchhikingDescription')}</SectionHeading>
      </div>

      {/* Post a Trip */}
      <div className="flex flex-col items-center">
        <SectionHeading size="sm">{t('HitchhikingDescription1')}</SectionHeading>
        <img className="my-3 md:my-4 w-[90%] max-w-[200px]" src="../../../image/image 41.png" alt="Post a Trip" />
        <p className="text-sm md:text-base text-center px-2">
          {t('HitchhikingDescription1Note')}
        </p>
      </div>

      {/* Route Matching */}
      <div className="flex flex-col items-center">
        <SectionHeading size="sm">{t('HitchhikingDescription2')}</SectionHeading>
        <img className="my-3 md:my-4 w-[90%] max-w-[200px]" src="../../../image/image 42.png" alt="Route Matching" />
        <p className="text-sm md:text-base text-center px-2">
          {t('HitchhikingDescription2Note')}
        </p>
      </div>

      {/* Easy Carpooling */}
      <div className="flex flex-col items-center">
        <SectionHeading size="sm">{t('HitchhikingDescription3')}</SectionHeading>
        <img className="my-3 md:my-4 w-[90%] max-w-[200px]" src="../../../image/image 43.png" alt="Easy Carpooling" />
        <p className="text-sm md:text-base text-center px-2">
          {t('HitchhikingDescription3Note')}
        </p>
      </div>
    </div>
  );
};

const SharedRidePage: React.FC = () => {
  return (
    <PageLayout>
      <div className="flex justify-center items-center w-full px-4 sm:px-0">
        <main className="flex flex-col items-center w-full sm:w-[90%] md:w-[85%] lg:w-[80%]">
          <HeroSection />
          <DescriptionSection />
        </main>
      </div>
    </PageLayout>
  );
}

export default SharedRidePage;